import {Component, computed, input} from '@angular/core';
import {NgForOf} from "@angular/common";
import {
    ScorecardIndividualPlayer,
    ScorecardParticipant
} from "../../../model/participant-card-model";
import {ProfileImageComponent} from "../../../../../common/component/profile/profile-image/profile-image.component";
import {TotalScoreComponent} from "../total/total-score.component";
import {ParticipantTotalScore} from "../../../model/total-score";

@Component({
    selector: 'individual-header',
    templateUrl: './individual-header.component.html',
    imports: [
        ProfileImageComponent,
        TotalScoreComponent,
        NgForOf

    ],
    styleUrls: ['./individual-header.component.css']
})
export class IndividualHeaderComponent {
    participant = input<ScorecardParticipant | undefined>();
    totals = input<ParticipantTotalScore[]>([]);
    player = computed(() => {
        return this.participant() as ScorecardIndividualPlayer
    });

    trackByMethod(_: number, participantTotalScore: ParticipantTotalScore) {
        return participantTotalScore.method
    };
}
